import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth.service';
import { HasWPermissionPipe } from './has-wpermission.pipe';



@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    AuthService
  ],
  declarations: [HasWPermissionPipe],
  exports: [HasWPermissionPipe]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<HasWPermissionPipe> {
    return {
        ngModule: HasWPermissionPipe,
        providers: [],
    };
}
}
